import React from 'react';
import clubImage from '../assets/images/home_firs_page.png';
import '../styles/About.css';

const AboutIntro = ({ language }) => {
  return (
    <section className="py-5 about-intro-section" id="about-intro">
      <div className="container">
        <div className="row align-items-center" data-aos="fade-up">
          <div className="col-lg-6 mb-4 mb-lg-0">
            <img src={clubImage} alt="Blue Nest Hotel" className="img-fluid rounded" />
          </div>
          <div className="col-lg-6">
<h2 className="fw-bold mb-3" style={{ color: '#1e3a8a' }}>
  {language === 'en' 
    ? 'About Blue Nest Hotel' 
    : 'ስለ ብሉ ኔስት ሆቴል'}
</h2>


<p>
  {language === 'en' 
    ? `Welcome to Blue Nest Hotel — a modern, welcoming destination in Addis Ababa. We offer relaxing stays, refined dining, and versatile venues for meetings and celebrations. Whether you are traveling for business or leisure, our dedicated team delivers warm, attentive service that makes every stay memorable.`
    : `ወደ ብሉ ኔስት ሆቴል እንኳን ደህና መጡ። በአዲስ አበባ ያለ ዘመናዊ እና እንኳን በደህና የሚቀበል መዳረሻ ነን። ምቹ መኖሪያ፣ ጥራት ያለው ምግብ እና ለስብሰባ እና ለዝግጅት ተስማሚ አዳራሾችን እንሰጣለን። ለንግድ ወይም ለማረፍ ቢጓዙም ቡድናችን በሙያ የተሞላ ሙቀት አገልግሎት ይሰጣል እና ቆይታዎን የማይረሳ ያደርጋል።`
  }
</p>

          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutIntro;
